import { createAction } from 'typesafe-actions';
import { Product } from 'types/product';

export const RELATED_PRODUCT_ITEM_IN_VIEWPORT = createAction('ui/RELATED_PRODUCT_ITEM_IN_VIEWPORT')<{
  productListId?: string;
  product: Product;
  productPositionFromOne: number;
}>();

export const RELATED_PRODUCT_ITEM_CLICK = createAction('ui/RELATED_PRODUCT_ITEM_CLICK')<{
  productListId?: string;
  product: Product;
  productPositionFromOne: number;
  elementName: 'productNameLink' | 'productPhotoLink' | 'productRatingLink';
}>();
